import { useEffect, useState } from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { watchTmsFlag } from './i18n/tms';
import { setLDClient } from './services/launchDarkly';

const AppLDProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLdClientSet, setIsLdClientSet] = useState(false);

  const launchdarklyClient = useLDClient();

  useEffect(() => {
    if (!launchdarklyClient) {
      return;
    }

    setLDClient(launchdarklyClient);
    const stopWatchingTmsFlag = watchTmsFlag(launchdarklyClient);
    setIsLdClientSet(true);
    return stopWatchingTmsFlag;
  }, [launchdarklyClient]);

  if (!isLdClientSet) {
    return null;
  }

  return children;
};

export default AppLDProvider;
